/* eslint-disable max-len */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import './quiz-styles.scss';
import { isValid, isText, decodeTags, segmentTrackEvent, removeTags } from '../../../../utils';
import QuizBox from './QuizBox';
import ShoppableStorefront from '../ShoppableStorefront/ShoppableStorefront';
import { PinterestShareButton } from 'react-share';

class Quiz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedResults: [],
      selectedAnswers: [],
      resultNum: null,
      notClicked: true,
      questionIndex: 0,
      showQuizLander: true,
    };
    this.startQuizRef = React.createRef();
    this.selectAnswer = this.selectAnswer.bind(this);
    this.calculateResult = this.calculateResult.bind(this);
    this.initializeArray = this.initializeArray.bind(this);
    this.retakeQuiz = this.retakeQuiz.bind(this);
    this.changeColor = this.changeColor.bind(this);
  }

  componentDidMount() {
    this.setState({
      selectedResults: this.initializeArray(),
      selectedAnswers: this.initializeArray(),
    });
  }

  changeColor() {
    this.setState({
      notClicked: !this.state.notClicked,
    });
  }

  retakeQuiz() {
    this.setState({
      selectedResults: this.initializeArray(),
      selectedAnswers: this.initializeArray(),
      resultNum: null,
      questionIndex: 0,
    });
  }

  initializeArray() {
    return this.props.data.questions.map((question, i) => null);
  }

  selectAnswer(answerData, questionIndex, answerIndex, quizType, nextQ, isMiniQuiz) {
    const answerText = removeTags(decodeTags(answerData.text)).replace(/\n/g, '');
    const answerImage = answerData.imageSrcDesktop
    const answer = isText(answerText) ? answerText : answerImage;
    segmentTrackEvent('quiz', {action: 'answer', hypercontext: answer});
    if (!isMiniQuiz) {
      setTimeout(() => {
        nextQ.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 200);
    }
    const prevAnswerArray = this.state.selectedAnswers;
    prevAnswerArray[questionIndex] = answerIndex;
    const prevResultsArray = this.state.selectedResults;
    let result = null;
    if (answerData.results.match(",")) {
	  const strArr = answerData.results.split(",");
	  const intArr = [];
	  for (let i = 0; i < strArr.length; i++) {
	    intArr.push(parseInt(strArr[i]));
	  }
	  result = intArr;
    } else {
	  result = parseInt(answerData.results);
    }
    prevResultsArray[questionIndex] = result;
    this.setState({
	  selectedAnswers: prevAnswerArray,
	  selectedResults: prevResultsArray,
    });

    if (!prevResultsArray.includes(null)) {
	  this.setState({ resultNum: this.calculateResult(quizType) });
    }
  }

  calculateResult(quizType) {
    const eventSpecific = {
        category: 'quiz',
        action: 'answer',
      }
    const resultArray = this.state.selectedResults.flat();
    let result = null;
    if (quizType === "personality") {
      const counted = resultArray.reduce((acc, curr) => {
		        if (curr in acc) {
		            acc[curr]++;
		        } else {
		            acc[curr] = 1;
		        }
		        return acc;
		    }, {});
	    	result = Object.keys(counted).reduce((a, b) => counted[a] > counted[b] ? a : b);
	    } else {
      result = resultArray.reduce((a, b) => a + b);
    }
    return result;
  }

  htmlDecode(input) {
    if (!isValid(input)) {
      return null;
    }
    try {
      var doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    } catch (e) {
      console.log(e);
      return null;
    }
    
  };

  render() {
    const { data, className, isMobile, seo, fullUrl } = this.props;
    if (!isValid(data)) { return null; }
    const { questions=[], results=[], quizType, quizStyle } = data;
    const isMiniQuiz = quizStyle === 'mini';
    let retakeText = this.htmlDecode(data.retakeText);
    const { resultNum, questionIndex } = this.state;
    let quizLander;
    let resultsCTA;

    if (isMiniQuiz) {
      const quizLanderData = results[0];
      const miniHeadline = isValid(quizLanderData) && isText(quizLanderData.miniHeadline) ? quizLanderData.miniHeadline : null;
      const quizCTA = isValid(quizLanderData) && isText(quizLanderData.quizCTA) ? quizLanderData.quizCTA : 'start the quiz';
      let miniLanderImage = isValid(quizLanderData) && isText(quizLanderData.miniLanderImage) ? quizLanderData.miniLanderImage : null;
      if (isValid(quizLanderData) && isText(quizLanderData.landerMobileImageOverride) && isMobile) {
        miniLanderImage = quizLanderData.landerMobileImageOverride
      }
      const miniLanderImageCredit = isValid(quizLanderData) && isText(quizLanderData.miniLanderImageCredit) ? quizLanderData.miniLanderImageCredit : null;
      const miniLanderImageCreditUrl = isValid(quizLanderData) && isText(quizLanderData.miniLanderImageCreditUrl) ? quizLanderData.miniLanderImageCreditUrl : null;
      resultsCTA = isValid(quizLanderData) && isText(quizLanderData.resultsCTA) ? quizLanderData.resultsCTA : 'next';
      quizLander = (
        <Fragment>
          <div className="quiz-lander-container">
            <div className="quiz-lander-text-wrapper">
              <QuizBox isQuiz={true} />
              <h2 className="mini-quiz-headline">{miniHeadline}</h2>
              <div className="quiz-lander-cta" onClick={() => {this.setState({showQuizLander: false})}}>
                {quizCTA}
              </div>
            </div>
            <div className="quiz-lander-img-wrapper">
                <a href={miniLanderImageCreditUrl} target="_blank" rel="noopener nofollow" >
                  <img className="quiz-lander-img" src={miniLanderImage} loading="lazy" />
                </a>
                <div className="quiz-lander-img-credit img-credit">
                  {miniLanderImageCredit}
                </div>
              {/* <div className="quiz-lander-imgage-container">
              </div> */}
            </div>
          </div>
        </Fragment>
      );
    }

    const renderedQuestions = questions.map((question, qi) => {
      // Removing "<p>" strings at the beginning/end of questions in our REST object:
      // this converts encoded html entities (p tags show up as &lt;p&gt; from our REST object) to string versions of the p tags within our questionText
      let questionText = decodeTags(question.questionText);
      // this replaces "<p>" and "</p>" from the beginning and end of the questionText with empty strings (removes them essentially), and replaces straight apostrophes with curly apostrophes (for single and double quotes)
      questionText = questionText ? questionText
        .replace(/<(.|\n)*?>/g, '')
        .replace(/(\s|^)\"([^\"]+)\"/g, '$1\u201C$2\u201D')
        .replace(/(\s|^)\'([^\"]+)\'/g, '$1\u2018$2\u2019')
        .replace(/'/g, '\u2019') : null;

      const nextQuestionRef = React.createRef();
      const { answers=[] } = question;
      // answerClass checks if answer is an image or text, and assigns the appropriate className
      const answerClass = (isValid(answers[0].imageSrcDesktop) && isValid(answers[0].imageSrcMobile)) ? 'answers-img-container' : 'answers-text-container';

      // ORIGINAL SCROLLNOW FUNCTION
      // const scrollNow = () => nextQuestionRef.current.scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
      
      const renderedAnswers = answers.map((answer, i) => {
        // selectedClass assigns className to each answer based on if it's clickable vs it's been selected
        const selectedClass = (this.state.selectedAnswers[qi] === i) ? 'clickable-answer selected' : 'clickable-answer';
        // Removing "<p>" strings at the beginning/end of questions in our REST object
        const answerText = decodeTags(answer.text);
        let imageSrc = null;
        // checking if answer contains an image or not, for conditional rendering purposes
    	  if (isValid(answer.imageSrcDesktop) && isValid(answer.imageSrcMobile.imageSrc)) {
    		imageSrc = isMobile ? answer.imageSrcMobile.imageSrc : answer.imageSrcDesktop;
    	  }
        
        return (
          <div
            onClick={() => { 
              const nextQ = nextQuestionRef.current;
              this.selectAnswer(answer, qi, i, quizType, nextQ, isMiniQuiz);
            }}
            key={answer.results}
            className={selectedClass}
          >
          {/* Rendering list of answers for each quiz question */}
            { imageSrc
              ? <div className="answer-with-image">
                  <img className="answer-img" src={imageSrc} loading="lazy"/>
                  <div className="answer-img-credit img-credit">{answer.photoCredit}</div>
                  <h3 className="answer-text" dangerouslySetInnerHTML={{ __html: answerText }} />
                </div>
              : <div className="answer-without-image">
                  {!isMiniQuiz && <div className="answer-dot"></div>}
                  <h3 className="answer-text" dangerouslySetInnerHTML={{ __html: answerText }} />
                </div>
            }
          </div>
        );
      });
      if (isMiniQuiz) {
        const showQuestion = questionIndex === qi;
        const allowNext = isValid(this.state.selectedAnswers[qi]) && isValid(this.state.selectedResults[qi]);
        const renderedDots = questions.map((q, i) => {
          return (
            <div className={`question-dot ${(i === questionIndex) ? 'solid' : ''}`}></div>
          );
        });
        const showResultsCTA = (this.state.selectedAnswers.length === questionIndex + 1) && resultsCTA;
        return (
          <Fragment>
            <div className={`question-container ${!showQuestion ? 'hide' : ''}`}>
              <div className="quiz-question">
                <h2 className="question-title" dangerouslySetInnerHTML={ { __html: (qi+1) + '. ' + questionText } }></h2>
              </div>
              <div className={answerClass}>
                {renderedAnswers}
              </div>
              {isMobile &&
                <div className="dots">
                  {renderedDots}
                </div>
              }
              <div className="quiz-tracker">
                 <div
                  className="start-over"
                  onClick={() => {
                    this.retakeQuiz();
                    this.setState({ showQuizLander: true });
                  }}
                >
                  start over
                </div>
                {!isMobile &&
                  <div className="dots">
                    {renderedDots}
                  </div>
                }
                <div className={`next ${allowNext ? '' : 'inactive'}`}
                  onClick={() => { 
                    if (allowNext) {
                      this.setState({questionIndex: questionIndex + 1})
                    }
                  }}
                >{showResultsCTA ? resultsCTA : 'next'}</div>
              </div>
            </div>
          </Fragment>
        )
      } else {
        return (
          <Fragment>
            {/* Rendering quiz question */}
            <div className="quiz-question">
              <h2 className="question-num">{qi+1}.</h2>
              <h2 className="question-title" dangerouslySetInnerHTML={ { __html: questionText } }></h2>
            </div>
              {/* Rendering list of answers and assigning the answerClass (answer-without-image or answer-with-image) */}
            <div className={answerClass}>
              {renderedAnswers}
            </div>
            {/* Adding ref */}
            <div className="ref-container">
              <div className="ref-offset" ref={nextQuestionRef}/>
            </div>
          </Fragment>
          );
      }
    });

    // Render quiz result, Take Quiz Again button
    let	renderedResult = results.map((result, i) => {
      if (!isValid(result)) { 
        return null;
      } else {
        if (parseInt(result.value) == (resultNum)) {
          let resultText = decodeTags(result.text);
          let resultTitle = decodeTags(result.title);
          const isSpotlightQuiz = isValid(result.shoppable);
          let resultShoppable = isSpotlightQuiz ? result.shoppable.data : null;

          const relatedTag = '<p class="related-story-link">';
          const renderedRelatedTag = '<div class="related-story-link-container">';
          const hasRelatedStoryLink = (isText(resultText) && resultText.includes(relatedTag) && !resultText.includes(renderedRelatedTag));
          const strongTag = '<strong>RELATED</strong>: ';
          let relatedLinkBodyText = '';
          // if resultText includes relatedTag, save the body text and the related story link into their own variables to render:
          if (isText(resultText) && hasRelatedStoryLink) {
            // find index where relatedTag begins
            let relatedStartIndex = resultText.indexOf(relatedTag);
            // save the related tag and its contents in a variable
            relatedLinkBodyText = resultText.slice(relatedStartIndex);
            // find the index where the closing p tag of the related story link ends
            let relatedEndIndex = relatedLinkBodyText.indexOf('</p>');
            // save the body text that was getting included within the related link container into its own variable
            relatedLinkBodyText = relatedLinkBodyText.substring(0, relatedEndIndex);
            if (relatedLinkBodyText.includes('&nbsp;')) {
              relatedLinkBodyText = relatedLinkBodyText.replace(/&nbsp;/g, ' ');
            }
            if (relatedLinkBodyText.includes(strongTag)) {
              relatedLinkBodyText = relatedLinkBodyText.replace(strongTag, '');
            }
            const included = relatedLinkBodyText.toLowerCase().includes('related: ');
            if (included) {
              relatedLinkBodyText = relatedLinkBodyText.toLowerCase().replace('related: ', '');
            }
            // save the bodyText minus relatedLinkBodyText text in a new variable
            resultText = resultText.slice(0, relatedStartIndex);
          }
  
          let resultImageSrc = isValid(result.imageSrcDesktop) ? result.imageSrcDesktop : null;
          if (isMobile) {
            resultImageSrc = isValid(result.resultMediaOverride) ? result.resultMediaOverride : result.imageSrcMobile;
          }
  
          const btnClass = this.state.notClicked ? 'take-quiz-btn' : 'take-quiz-btn-active';
          const showPin = (isValid(result.url) && resultImageSrc);

          segmentTrackEvent('quiz', {action: 'result', hypercontext: resultTitle});

          if (isMiniQuiz) {
            return (
              <div className="results-container">
                {isValid(result.url) ? (
                <div className="results-img-wrapper">
                    <a href={result.url} target="_blank" rel="noopener nofollow">
                      <img className="results-img" src={resultImageSrc} loading="lazy"/>
                    </a>
                    <div className="results-img-credit text" dangerouslySetInnerHTML={{ __html: result.imageCredit }}></div>
                </div>
                ) : (
                <div className="results-img-wrapper">
                    <img className="results-img" src={resultImageSrc} loading="lazy"/>
                    <div className="results-img-credit text" dangerouslySetInnerHTML={{ __html: result.imageCredit }}></div>
                </div>
                )}
                <div className="results-text-wrapper">
                  <span className="results">Results</span>
                  <h2 className="results-title" dangerouslySetInnerHTML={{ __html: resultTitle }}/>
                  <h4 className="results-text" dangerouslySetInnerHTML={{ __html: resultText }}/>
                  <div
                    className={btnClass}
                    onClick={() => {
                      this.retakeQuiz();
                      this.setState({ showQuizLander: true });
                      segmentTrackEvent("quiz", {
                        label: "retake",
                        action: "click",
                      });
                    }}
                  >
                    {/* If retake quiz text override is used, show that text in place of 'Take the quiz again' */}
                    {!retakeText ? "Retake The Quiz" : retakeText}
                  </div>
                </div>
              </div>
            )
          }
          if (isSpotlightQuiz) {
              return (
                  <div className="results-container">
                  <div className="results-background-color shoppable"></div>
                  <span className="results">Results</span>
                  <h2 className="results-title shoppable" dangerouslySetInnerHTML={{ __html: resultTitle }}/>
                  {(isValid(resultImageSrc) && isValid(result.url)) && 
                  <div className="results-img-wrapper">
                      <a href={result.url} target="_blank" rel="noopener nofollow">
                        <img className="results-img" src={resultImageSrc} loading="lazy"/>
                      </a>
                      {showPin &&
                        <div className="social-pin-wrapper">
                          <PinterestShareButton
                            className="social-share-unit pinterest"
                            onClick={() => segmentTrackEvent('pinterest_share', {action: 'social', label: 'pin_share'})}
                            url={fullUrl}
                            alt={result.imageAlt || 'pinterest share image'}
                            description={seo.metaDescription}
                            media={resultImageSrc || 'https://www.purewow.com/static-gmg/purewow/logos/purewow-mark-salmon.jpg'}>
                          </PinterestShareButton>
                        </div> 
                      }
                      <div className="results-img-credit text" dangerouslySetInnerHTML={{ __html: result.imageCredit }}></div>
                  </div>
                  }
                  {(isValid(resultImageSrc) && !isValid(result.url)) &&
                    <div className="results-img-wrapper">
                        <img className="results-img" src={resultImageSrc} loading="lazy"/>
                        <div className="results-img-credit text" dangerouslySetInnerHTML={{ __html: result.imageCredit }}></div>
                    </div>
                  }
      
                  <h4 className="results-text shoppable" dangerouslySetInnerHTML={{ __html: resultText }}/>
  
                  <div className='results-shoppable'>
                    <ShoppableStorefront data={resultShoppable} isSpotlightQuiz={isSpotlightQuiz} />
                  </div>

                  <div
                    className={btnClass}
                    onClick={() => {
                      this.changeColor();
                      segmentTrackEvent('quiz', { label: 'retake', action: 'click',});
                      setTimeout(() => {
                        this.retakeQuiz();
                        this.startQuizRef.current.scrollIntoView();
                      }, 200);
                    }}
                    >
                    {/* If retake quiz text override is used, show that text in place of 'Take the quiz again' */}
                    { !retakeText ? "Take The Quiz Again" : retakeText }
                  </div>
                </div>
              )
            }
          if (!isSpotlightQuiz) {
              return (
                <div className="results-container">
                  <div className="results-background-color"></div>
                  <span className="results">Results</span>
                  <h2 className="results-title" dangerouslySetInnerHTML={{ __html: resultTitle }}/>
                  {isValid(result.url) ? (
                  <div className="results-img-wrapper">
                      <a href={result.url} target="_blank" rel="noopener nofollow">
                        <img className="results-img" src={resultImageSrc} loading="lazy"/>
                      </a>
                      {showPin &&
                        <div className="social-pin-wrapper">
                          <PinterestShareButton
                            className="social-share-unit pinterest"
                            onClick={() => segmentTrackEvent('pinterest_share', {action: 'social', label: 'pin_share'})}
                            url={fullUrl}
                            alt={result.imageAlt || 'pinterest share image'}
                            description={seo.metaDescription}
                            media={resultImageSrc || 'https://www.purewow.com/static-gmg/purewow/logos/purewow-mark-salmon.jpg'}>
                          </PinterestShareButton>
                        </div> 
                      }
                      <div className="results-img-credit text" dangerouslySetInnerHTML={{ __html: result.imageCredit }}></div>
                  </div>
                  ) : (
                  <div className="results-img-wrapper">
                      <img className="results-img" src={resultImageSrc} loading="lazy"/>
                      <div className="results-img-credit text" dangerouslySetInnerHTML={{ __html: result.imageCredit }}></div>
                  </div>)
                  }
      
                  <h4 className="results-text" dangerouslySetInnerHTML={{ __html: resultText }}/>

                  { hasRelatedStoryLink && 
                    <div className='related-story-link-container'>
                      <div class="related-header"><strong>RELATED</strong><hr></hr></div>
                      <div className="related-story-link-contents" dangerouslySetInnerHTML={{ __html: relatedLinkBodyText }}></div>
                      <hr></hr>
                    </div>
                  }
    
                  <div
                    className={btnClass}
                    onClick={() => {
                      this.changeColor();
                      segmentTrackEvent('quiz', { label: 'retake', action: 'click',});
                      setTimeout(() => {
                        this.retakeQuiz();
                        this.startQuizRef.current.scrollIntoView();
                      }, 200);
                    }}
                    >
                    {/* If retake quiz text override is used, show that text in place of 'Take the quiz again' */}
                    { !retakeText ? "Take The Quiz Again" : retakeText }
                  </div>
                </div>
              );
            }
          }
        }
      });

    if (isMiniQuiz && this.state.questionIndex !== this.state.selectedAnswers.length) {
      renderedResult = <></>;
    }
    return (
      <div className={`${className}${isMiniQuiz ? " mini" : ""}`}>
        {isMiniQuiz && this.state.showQuizLander ? (
          quizLander
        ) : (
          <>
            <div className="start-quiz-ref" ref={this.startQuizRef} />
            {renderedQuestions}
            {resultNum !== null && renderedResult}
          </>
        )}
      </div>
    );
  }
}

Quiz.propTypes = {
  className: PropTypes.string,
};

export default Quiz;
